import { render, staticRenderFns } from "./KategoriSection.vue?vue&type=template&id=0b7bc6be&"
import script from "./KategoriSection.vue?vue&type=script&lang=js&"
export * from "./KategoriSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports